import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
// Import Components
import { RfqWidget } from '@jelly/components'; // Styled Components via Emotion

var PricingContainer = _styled("div", {
  target: "eb5f32d0",
  label: "PricingContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "8atqhb",
  styles: "width:100%;"
} : {
  name: "8atqhb",
  styles: "width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9DYXRlZ29yeS9zZW8vUHJpY2luZy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUW1DIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9DYXRlZ29yeS9zZW8vUHJpY2luZy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnXG5cbi8vIEltcG9ydCBDb21wb25lbnRzXG5pbXBvcnQgeyBSZnFXaWRnZXQgfSBmcm9tICdAamVsbHkvY29tcG9uZW50cydcblxuLy8gU3R5bGVkIENvbXBvbmVudHMgdmlhIEVtb3Rpb25cbmNvbnN0IFByaWNpbmdDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuXHR3aWR0aDogMTAwJTtcbmBcblxuUHJpY2luZy5wcm9wVHlwZXMgPSB7XG5cdGludHJvOiBzdHJpbmcuaXNSZXF1aXJlZCxcblx0d2lkZ2V0SWQ6IHN0cmluZy5pc1JlcXVpcmVkLFxufVxuXG4vKipcbiAqIFRoaXMgaXMgdGhlIFByaWNpbmcgU2VjdGlvbiBmb3IgY2F0ZWdvcnkgcGFnZXNcbiAqIFdpbGwgZGlzcGxheSB0aGUgaW50cm8gYW5kIHJmcSB3aWRnZXRcbiAqXG4gKiBUT0RPOiBjaGVjayBkYXRhIHdpZGdldElkXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBQcmljaW5nKHsgaW50cm8sIHdpZGdldElkIH0pIHtcblx0cmV0dXJuIChcblx0XHQ8UHJpY2luZ0NvbnRhaW5lcj5cblx0XHRcdDxkaXYgZGFuZ2Vyb3VzbHlTZXRJbm5lckhUTUw9e3sgX19odG1sOiBpbnRybyB9fT48L2Rpdj5cblx0XHRcdDxSZnFXaWRnZXQgd2lkZ2V0Q2F0ZWdvcnlJZD17d2lkZ2V0SWR9IC8+XG5cdFx0PC9QcmljaW5nQ29udGFpbmVyPlxuXHQpXG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * This is the Pricing Section for category pages
 * Will display the intro and rfq widget
 *
 * TODO: check data widgetId
 */
export function Pricing(_ref) {
  var intro = _ref.intro,
      widgetId = _ref.widgetId;
  return /*#__PURE__*/React.createElement(PricingContainer, null, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: intro
    }
  }), /*#__PURE__*/React.createElement(RfqWidget, {
    widgetCategoryId: widgetId
  }));
}